<template lang="pug">
.slide-layout
  .slide-title 指定人群
  .list-checkbox
    .list-item(v-for="(item, index) in list")
      .radio
        input(type="radio", :id="'type' + index", v-model="checked", :value="item.id")
        label(:for="'type' + index", v-text="item.name")
      el-popover.tips-text(placement="top-start", width="200", trigger="hover", :content="item.desc")
        .el-icon-question(slot="reference")
      .num(v-if="item.id === 1") {{info.place_order_customer}}人
      .num(v-if="item.id === 2") {{info.unplace_order_customer}}人
  .btn
    button.button.large.primary(@click="saveInfo" v-text="'确定'")
</template>

<script>
import Api from '@/mixins/modules/marketing'
export default {
  name: 'MessageType',
  mixins: [Api],
  components: {
  },
  props: {
    id: {
      type: [String, Number],
    },
  },
  data () {
    return {
      list: [
        {name: '小程序未下单客户', checked: false, id: 2, desc: '已注册小程序但还未下单的客户'},
        {name: '小程序已下单客户', checked: false, id: 1, desc: '已在小程序成功下单的客户，包括商品服务、养护卡、拼团秒杀、线下买单'},
      ],
      checked: '',
      info: {},
    }
  },
  methods: {
    // 获取分类id
    saveInfo () {
      if (!this.checked) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '温馨提示',
          content: '请选择指定人群',
        })
        return false
      }
      this.$emit('success', this.checked)
    },
    // 获取分类数据
    async fetchCategory () {
      try {
        const {response, result} = await this.getSmsCategoryApi()
        if (response.status === 200 && result.code === 0) {
          this.info = result.data
          this.info.unplace_order_customer = this.info.register_customer - this.info.place_order_customer
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取推荐客户失败',
            content: result.message,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取推荐客户失败',
          content: '服务异常，请稍后再试',
        })
      }
    },
  },
  mounted () {
    this.checked = this.id
    this.fetchCategory()
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/mixins'
.list-checkbox
  padding-bottom 30px
  .list-item
    height 30px
    line-height 30px
    .checkbox label
      padding-left 30px
  .num
    float right 
    font-size 12px
    color #666
</style>



// WEBPACK FOOTER //
// src/components/content/modal/ChooseCustomer.vue